import { useEffect, useEffectEvent } from 'react';

/**
 * ios-tab-bar — runs `onHide` when the screen leaves view: when a kept-alive
 * tab is hidden (its `<Activity>` runs effect cleanups) and when it unmounts
 * (Android, web). For state a fresh mount used to reset on each visit.
 */
export function useOnHide(onHide: () => void) {
  const fire = useEffectEvent(onHide);
  useEffect(() => () => fire(), []);
}
